import { Action } from '@ngrx/store';
import {AddUpdateDeviceParams, EmbCardInfo, EmbCardParams} from '../../../models/devices';

export enum BindEmbCardActionTypes {
  LoadBindEmbCards = '[BindEmbCard] Load BindEmbCards',
  GetBindEmbCards = '[BindEmbCard] Get BindEmbCards',
  ClearBindEmbCards = '[BindEmbCard] Clear BindEmbCards',
}

export class LoadBindEmbCards implements Action {
  readonly type = BindEmbCardActionTypes.LoadBindEmbCards;
  constructor(public payload: AddUpdateDeviceParams) {}
}

export class GetBindEmbCards implements Action {
  readonly type = BindEmbCardActionTypes.GetBindEmbCards;
  constructor(public payload: EmbCardParams) {}
}

export class ClearEmbCards implements Action {
  readonly type = BindEmbCardActionTypes.ClearBindEmbCards;
}


export type BindEmbCardActions = LoadBindEmbCards
| GetBindEmbCards
| ClearEmbCards;

